import React from 'react'
import { Autocomplete, Divider, Grid, ListItemIcon, ListItemText, TableCell, TableRow, TextField, Typography } from '@mui/material';
import { useContext } from 'react';
import globalStyles from "../../../../../../assets/styles/global.module.scss";
import whatsAppCampaignStyles from "../../../../../../assets/styles/componentStyles/whatsappCampaignStyles/whatsappCampaignStyle.module.scss"
import contactStyles from "../../../../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss"
import styles from "../../../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowCreate.module.scss"
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import IconsColor from '../../../../../utility/iconsColor';
import { customVariableDataInterface } from '../../../../../../models/axiosModel';
import { isCurrentViewVersionPublished } from '../../../utilityFunctions';
import { WorkflowContext, WorkflowContextPayload } from '../../../../../../context/workflowContext';
import { useFlowBuilderStore } from '../../../../../../store/flowBuilderStore';
import { primaryColor } from '../../../../../../utils/colors';
import { FlowBuilderContext, FlowBuilderContextPayload } from '../../../../../../context/flowBuilderContext';
import { getVariableLabelName, getVariableOptionsBasedOnVariableType, getVariableTypeValue, getVariableValue } from '../../../flowBuilderConstants';

const MemoizedRow = React.memo((props: any) => {
    const { payload, ind, parameter, onChangeOfField, onChangeOfFallbackValue,
        setFlagEditResVarPathPopup, setSelectedResPayload, onChangeOfFieldVariableType,
        fieldKeyName, flagVariableAssignment
    } = props
    const customVariableList = useFlowBuilderStore((state) => state.customVariableList)
    const setFlagDataCollectionPopup = useFlowBuilderStore((state) => state.setFlagDataCollectionPopup)
    const setFlagUpdateFieldData = useFlowBuilderStore((state) => state.setFlagUpdateFieldData)
    const existingCustomVariablePayload = useFlowBuilderStore((state) => state.existingCustomVariablePayload)
    const setFlagDeleteData = useFlowBuilderStore((state) => state.setFlagDeleteData)
    const setExistingCustomVariablePayload = useFlowBuilderStore((state) => state.setExistingCustomVariablePayload)


    const { variableTypes } = useContext(FlowBuilderContext) as FlowBuilderContextPayload
    const metaDataVariableList = useFlowBuilderStore((state) => state.metaDataVariableList)

    const { currentActiveStaticWorkflow } = useContext(WorkflowContext) as WorkflowContextPayload

    const handleEditFieldData = (event: any, option: customVariableDataInterface) => {
        event.stopPropagation();
        setFlagDataCollectionPopup(true);
        setFlagUpdateFieldData(true);
        setExistingCustomVariablePayload({
            ...existingCustomVariablePayload,
            chatbot_custom_variable_config_id: option.chatbot_custom_variable_configuration_id,
            chatbot_custom_variable_name: option.chatbot_custom_variable_name,
            chatbot_custom_variable_fallback_value: option.chatbot_custom_variable_fallback_value
        })
    }

    const handleDeleteFieldData = (event: any, option: customVariableDataInterface) => {
        event.stopPropagation();
        setExistingCustomVariablePayload({
            ...existingCustomVariablePayload,
            chatbot_custom_variable_config_id: option.chatbot_custom_variable_configuration_id,
            chatbot_custom_variable_name: option.chatbot_custom_variable_name,
            chatbot_custom_variable_fallback_value: option.chatbot_custom_variable_fallback_value
        })
        if (setFlagDeleteData) {
            setFlagDeleteData(true)
        }
    }


    const renderOptions = (props: React.HTMLAttributes<HTMLLIElement>, option: any): React.ReactNode => {
        if (option.chatbot_custom_variable_configuration_id == "-1" && option.chatbot_custom_variable_name == "New Field") {
            return (
                <ul className={contactStyles.newTagNameUlElement}>
                    <Divider className={contactStyles.newTagDivider} />
                    <li {...props} style={{ minHeight: "auto", cursor: "pointer", padding: "10px 16px", display: "flex", alignItems: "center", gap: "5px", boxSizing: "border-box", outline: "none", color: primaryColor }} onClick={() => { setFlagDataCollectionPopup(true); }}>
                        <AddIcon />
                        <Typography sx={{ fontSize: "15px", fontWeight: "500" }}>New Field</Typography>
                    </li>
                </ul>
            )
        }
        return (
            <li {...props} key={option.chatbot_custom_variable_configuration_id}>
                <Grid container className={globalStyles.wordBreakBreakAll}>
                    <ListItemText primary={option.chatbot_custom_variable_name} className={styles.listItemsStyle} />
                </Grid>
                <Grid container justifyContent={"end"} sx={{ maxWidth: "60px" }}>
                    <Grid item onClick={(e) => e.stopPropagation()}>
                        <ListItemIcon onClick={(event) => handleEditFieldData(event, option)} sx={{ padding: "0", minWidth: "10px !important" }}>
                            <EditIcon sx={{ height: "14px", width: "14px", fontSize: "14px" }} />
                        </ListItemIcon>
                    </Grid>
                    <Grid item onClick={(e) => e.stopPropagation()} paddingLeft={"12px"}>
                        <ListItemIcon onClick={(event) => handleDeleteFieldData(event, option)} sx={{ padding: "0", minWidth: "10px !important" }}
                        >
                            <IconsColor height="14" width="14" iconName="DeleteIcon" fillColor="#7A7A7A" />
                        </ListItemIcon>
                    </Grid>
                </Grid>
            </li>
        )
    }

    function getRenderOptions() {
        let variableType = payload[ind]?.variable_type?.variable_type_name
        switch (variableType?.toLowerCase()) {
            case 'metadata':
                return undefined
            default:
                return renderOptions
        }
    }

    const checkIfPathChanged = (path: string) => {
        if (path) {
            const bracketMatches = path.match(/\[([^\]]+)\]/g);
            if (bracketMatches) {
                return bracketMatches.some(item => /^\["?\d+"?\]$/.test(item));
            }
            return false;
        } else {
            return false;
        }
    }
    function getListBoxProps() {
        let variableType = payload[ind]?.variable_type?.variable_type_name
        switch (variableType?.toLowerCase()) {
            case 'metadata':
                return undefined
            default:
                return { style: { maxHeight: '150px', overflow: 'auto', paddingBottom: "50px" } }
        }
    }

    const checkDisableFallbackValue = () => {
        if(flagVariableAssignment){
            return !(parameter?.variable_type);
        } else {
            return !(parameter?.chatbot_custom_variable_configuration_id);
        }
    }

    return <>
        <TableRow key={ind} className={whatsAppCampaignStyles.tableRow}>
            <TableCell className={whatsAppCampaignStyles.tableSubHeadingFontStyle}>
                <Grid container className={globalStyles.flexColumn} gap={"3px"}>
                    <Grid item> {parameter.key} </Grid>
                    <Grid item className={styles.responseVariablePathText} sx={{ color: "#4C4A4D" }}>
                        {/* Type: {`${parameter.function_parameter_type_name.charAt(0).toUpperCase()}${parameter.function_parameter_type_name.slice(1)}`} */}
                    </Grid>

                    <Grid item>
                        <Grid container gap={"3px"} className={styles.responseVarEditPathContainer}>
                            <Grid item className={styles.responseVariablePathText} sx={{ color: checkIfPathChanged((payload as any[])[ind]?.action_custom_api_call_response_variable_path) ? "#2d2828" : "#4C4A4D" }}>
                                Path: {fieldKeyName == "action_await_webhook_identifier_field_data" ? parameter.identifier_field_path : parameter.field_value_path}
                            </Grid>
                            {parameter.insideArray &&
                                <Grid
                                    item
                                    className={`${globalStyles.displayFlexStyle} ${styles.responseVariablePathEditIconGrid}`}
                                    onClick={() => {
                                        setFlagEditResVarPathPopup(true);
                                        setSelectedResPayload((payload as any[])[ind]);
                                    }}>
                                    <EditIcon className={styles.responseVariablePathEditIcon} />
                                </Grid>
                            }
                        </Grid>
                    </Grid>
                </Grid>
            </TableCell>
            
            {flagVariableAssignment && 
                <TableCell className={whatsAppCampaignStyles.tableSubHeadingFontStyle} sx={{ minWidth: "150px" }}>
                    <Autocomplete
                        key={ind}
                        disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                        className={`${contactStyles.contactFilterDropdownsInPopup} ${globalStyles.fullwidth}`}
                        options={variableTypes}
                        getOptionLabel={(option) => option.variable_label || ''}
                        value={parameter?.variable_type?.variable_type_name ? getVariableTypeValue(variableTypes, parameter.variable_type?.variable_type_name) : null}
                        sx={{ '&:hover': { backgroundColor: "white !important" }, backgroundColor: "white !important" }}
                        onChange={(_: React.SyntheticEvent, value: customVariableDataInterface | null) => {
                            onChangeOfFieldVariableType(value, ind, fieldKeyName);
                        }}
                        renderInput={(params) => <TextField {...params} placeholder="Select Field Type" />}
                    />
                </TableCell> 
            } 
            <TableCell className={whatsAppCampaignStyles.tableSubHeadingFontStyle} sx={{ minWidth: "150px" }}>
                {(!flagVariableAssignment || (parameter?.variable_type?.variable_type_name && (parameter?.variable_type?.variable_type_name == "Custom" || parameter?.variable_type?.variable_type_name == "Metadata"))) ?
                    <Autocomplete
                        key={ind}
                        disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                        className={`${contactStyles.contactFilterDropdownsInPopup} ${globalStyles.fullwidth}`}
                        options={getVariableOptionsBasedOnVariableType(customVariableList, metaDataVariableList, payload[ind]?.variable_type?.variable_type_name, currentActiveStaticWorkflow) || []}
                        getOptionLabel={(option: any) => option[getVariableLabelName(payload[ind]?.variable_type?.variable_type_name)] || ''}
                        value={getVariableValue(customVariableList, metaDataVariableList, currentActiveStaticWorkflow, parameter?.variable_type?.variable_type_name || null, parameter.chatbot_custom_variable_configuration_id || null, parameter.metadata_type?.metadata_type_id || null)}
                        sx={{ '&:hover': { backgroundColor: "white !important" }, backgroundColor: "white !important" }}
                        onChange={(_: React.SyntheticEvent, value: customVariableDataInterface | null) => {
                            onChangeOfField(value, ind, fieldKeyName);
                        }}
                        ListboxProps={getListBoxProps()}
                        renderOption={getRenderOptions()}
                        renderInput={params => {
                            const { InputProps, ...restParams } = params;
                            const { startAdornment, ...restInputProps } = InputProps;
                            return (
                                <TextField
                                    {...restParams}
                                    placeholder='Select Field'
                                    InputProps={{
                                        ...restInputProps,
                                        startAdornment: (
                                            <div style={{
                                                maxHeight: "90px",
                                                overflowY: 'auto',
                                            }}
                                            >
                                                {startAdornment}
                                            </div>
                                        ),
                                    }}
                                />
                            );
                        }}
                    />
                    :
                    "NA"
                }
            </TableCell>
            <TableCell className={whatsAppCampaignStyles.tableSubHeadingFontStyle}>
                <TextField
                    disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow) || checkDisableFallbackValue()}
                    value={fieldKeyName == "action_await_webhook_identifier_field_data" ? parameter.action_await_webhook_identifier_variable_fallback_value : parameter.fallback_value}
                    placeholder='Enter Fallback Value' 
                    onChange={(e) => {
                        onChangeOfFallbackValue(e.target.value, ind, fieldKeyName);
                    }}
                    className={whatsAppCampaignStyles.whatsappCampaignTextField}
                    sx={{ width: "100%", backgroundColor: "white" }}
                />
            </TableCell>
        </TableRow>
    </>
}, areEqualMemoizedRow)
function areEqualMemoizedRow(prevProps: any, nextProps: any) {
    const sameIndex = prevProps.ind === nextProps.ind;
    const sameParameter = JSON.stringify(prevProps.parameter) === JSON.stringify(nextProps.parameter);
    const samePayloadEntry = JSON.stringify(prevProps.payload[prevProps.ind]) === JSON.stringify(nextProps.payload[nextProps.ind]);

    return (
        sameIndex &&
        sameParameter
        &&
        samePayloadEntry
    );
}
export default MemoizedRow